// extracted by mini-css-extract-plugin
export var container = "_p3-0";
export var dotAnimation = "_p3-2";
export var dotsLoading = "_p3-1";